import { render, staticRenderFns } from "./appr-welltest.vue?vue&type=template&id=353b612b&scoped=true"
import script from "./appr-welltest.vue?vue&type=script&lang=js"
export * from "./appr-welltest.vue?vue&type=script&lang=js"
import style0 from "./appr-welltest.vue?vue&type=style&index=0&id=353b612b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b612b",
  null
  
)

export default component.exports